import React, { memo } from 'react';
import Styles from './auth-layout-styles.scss';
const AuthLayout = (props) => React.createElement("div", Object.assign({ className: Styles.authWrapper }, props));
export default memo(AuthLayout);
